var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"pageFooter",class:{
    'pageFooter--dark': _vm.theme === 'dark',
    'pageFooter--light': _vm.theme === 'light'
  }},[_c('a',{attrs:{"href":"https://www.ysl.com/en-en/legal-notices/name/terms-and-conditions-use.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Legal Notice")])])}
var staticRenderFns = []

export { render, staticRenderFns }